import cx from 'classnames'
import * as React from 'react'

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Link from '../Link/Link'
import NotificationCount from '../NotificationCount/NotificationCount'
import styles from './pageLinks-style.css'

type Props = {
  items: Array<LinkViewModel>
  notificationCount?: string
}
type State = {}

class PageLinks extends React.Component<Props, State> {
  static displayName = 'PageLinks'
  static defaultProps = {}

  renderItem = (item: LinkViewModel) => {
    const { notificationCount } = this.props

    return (
      <li key={item.href} className={styles.item}>
        <Link
          {...item}
          noUnderline
          className={cx(styles.link, {
            [styles.linkActive]: item.active,
          })}
        >
          {item.label}
          {notificationCount && <NotificationCount notificationCount={notificationCount} />}
        </Link>
      </li>
    )
  }

  render() {
    const { items } = this.props

    if (!items) {
      return null
    }

    return <ul className={styles.pageLinks}>{items.map(this.renderItem)}</ul>
  }
}

export default PageLinks